<template>
    <div class="vue-grid-overview col-12">
        <div class="row">
            <template v-for="(vehicle, index) in vehicles">
                <div class="col-sm-6 col-md-4 col-xl-3"
                     v-if="showCta && parseInt(index + 1) === parseInt(cta.position) && !iframe">
                    <aut-vehicle-overview-cta :content="cta.content" :image="cta.image"></aut-vehicle-overview-cta>
                </div>

                <div class="col-sm-6 col-md-4 col-xl-3"
                     v-if="showSecondCta && parseInt(index + 1) === parseInt(secondCta.position) && !iframe">
                    <aut-vehicle-overview-cta :content="secondCta.content" :image="secondCta.image"></aut-vehicle-overview-cta>
                </div>

                <div class="col-sm-6 col-md-4 col-xl-3">
                    <aut-vehicle-teaser
                        :key="vehicle.id"
                        :id="vehicle.id"
                        :location-id="locationId"
                        :vehicle-data="vehicle"
                        :is-business="isBusiness"
                        :iframe="iframe"
                        is-wrapper
                    ></aut-vehicle-teaser>
                </div>
            </template>

            <template v-if="this.vehicles.length < 3">
                <div class="col-sm-6 col-xl-3">
                    <aut-vehicle-overview-cta :content="cta.content" :image="cta.image"></aut-vehicle-overview-cta>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "GridOverview",

    props: ['locationId', 'vehicles', 'cta', 'secondCta', 'isBusiness', 'iframe'],

    computed: {
        showCta() {
            return this.cta && !this.isBusiness && parseInt(this.cta.status) !== 0;
        },

        showSecondCta() {
            return this.secondCta && !this.isBusiness && parseInt(this.secondCta.status) !== 0;
        }
    },
}
</script>
